import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const ChapterAdd = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='ChapterAdd' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M5,14 L5,5 L19,5 L19,20 L11,20 M19,16 L23,16 L23,1 L9,1 L9,5 M5,16 L5,24 M9,20 L1,20' />
  </StyledIcon>
);
